import React, { useCallback } from "react";
import { Search } from "modules/common/components/form/Search";
import styles from "./Filters.module.scss";
import { Constants } from "modules/root/models/constants";
import { FiltersContract } from "./types";
import { PlanrButton } from "modules/common/components/planr/button/Button";
import { DefaultSelectedOption, renderSingleOption, SimpleSelect } from "modules/common/services/form/select";
import { Classes } from "@blueprintjs/core";
import { observer } from "mobx-react";
import { DictionaryItemSnapshotType } from "modules/common/models/entity";
import { ALL_MAILS } from "modules/common/constants";

export const Filters: React.FC<FiltersProps> = (props) => {
  const options: { [k: string]: DictionaryItemSnapshotType } = {};
  const filterStatuses = [ALL_MAILS, "Принято", "Исполнено", "Просрочено"];
  filterStatuses.forEach((label) => {
    options[label] = { id: label, label };
  });

  const { children, query, setQuery, hideProject } = props;
  const { filtersType, setFiltersType, toggleFiltersStatus, filtersStatus } = props;

  const selectType = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      let type = e.currentTarget.title;
      if (type === ALL_MAILS) {
        type = "";
      }
      setFiltersType(type || "");
    },
    [setFiltersType]
  );

  const selectStatuses = useCallback(
    (selection: string) => {
      let status = selection;
      if (selection === ALL_MAILS) {
        status = "";
      }

      toggleFiltersStatus(status || "");
    },
    [toggleFiltersStatus]
  );

  return (
    <div className={styles.filters}>
      <div className={"planr-mail-group"}>
        <PlanrButton
          type="neutral"
          icon={"general-mail"}
          round={true}
          onClick={selectType}
          title={ALL_MAILS}
          style={!filtersType ? {} : { color: "rgba(0, 39, 61, 0.4)" }}
          size="small"
        />

        <PlanrButton
          type="neutral"
          icon={"general-mail-in"}
          round={true}
          onClick={selectType}
          title={Constants.incomingOrderMailType}
          className="mail-group-btn"
          style={filtersType === Constants.incomingOrderMailType ? {} : { color: "rgba(0, 39, 61, 0.4)" }}
          size="small"
        />

        <PlanrButton
          type="neutral"
          icon={"general-mail-out"}
          round={true}
          onClick={selectType}
          title={Constants.outcomingOrderMailType}
          className="mail-group-btn"
          style={filtersType === Constants.outcomingOrderMailType ? {} : { color: "rgba(0, 39, 61, 0.4)" }}
          size="small"
        />
      </div>

      <div className={styles.statusFilter} style={!hideProject ? { width: "190px" } : {}}>
        {/* Выбранный статус берём из стора, а не из своего состояния: он меняется
            и мимо этого поля — повторный выбор того же статуса снимает фильтр,
            а выбор проекта сбрасывает его целиком. Плюс полей два (обычная шапка
            и мобильная), и у каждого своё состояние разъезжалось бы отдельно */}
        <StatusFilterHeader
          width={300}
          currentOptions={options}
          value={filtersStatus || ALL_MAILS}
          onChange={(status: any) => selectStatuses(status.label)}
        />
      </div>

      <div className={styles.tools}>
        {children}
        <Search query={query} onSearch={setQuery} />
      </div>
    </div>
  );
};

interface FiltersProps extends FiltersContract {
  hideProject?: boolean;
  children?: React.ReactNode;
}

interface StatusFilterHeaderProps {
  value: string;
  onChange: (value: any) => void;
  currentOptions: { [k: string]: any };
  width: number;
  filter?: string;
}

const StatusFilterHeader = observer(
  class extends React.Component<StatusFilterHeaderProps> {
    render() {
      const { width, value, currentOptions } = this.props;

      const option = currentOptions[value];

      return (
        <SimpleSelect
          className={`${Classes.FILL} planr-default-input`}
          filterable={false}
          items={Object.values(currentOptions)}
          itemRenderer={renderSingleOption}
          onItemSelect={this.onItemSelect}
        >
          <DefaultSelectedOption
            option={option}
            // empty означает «выбирать не из чего» — тогда поле показывает «Нет данных»
            // вместо значения. Жёсткое true не давало показать выбранный статус никогда
            empty={Object.keys(currentOptions).length === 0}
            style={{ overflow: "hidden", maxWidth: `${width - 3}px` }}
          />
        </SimpleSelect>
      );
    }

    onItemSelect = (item: SelectItem) => this.props.onChange(item);
  }
);
